import React from "react";

export default function Footer({
    company = "ZeroOne IT Solutions",
    year = new Date().getFullYear(),
    className = "",
    noBorder = false,
    noPadding = false,
    showLegalLinks = false,
}) {
    return (
        <div
            className={`w-full flex flex-col sm:flex-row flex-wrap justify-center items-center gap-1 sm:gap-2 text-xs text-gray-500 ${
                noPadding ? "" : "py-4"
            } ${noBorder ? "" : "border-t border-gray-200"} ${className}`}
        >
            <span>
                &copy; {year} {company}
            </span>
            <span className="hidden sm:inline text-gray-300">|</span>
            <span>All rights reserved</span>
            {showLegalLinks && (
                <>
                    <span className="hidden sm:inline text-gray-300">|</span>
                    <span className="text-gray-400">Secure POS Platform</span>
                </>
            )}
        </div>
    );
}
